module.exports = __webpack_public_path__ + "static/img/fiveBox.a076a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fiveBox.png
// module id = t2LA
// module chunks = 1